import { render } from "./AgendaForm.vue?vue&type=template&id=3468ebae&scoped=true"
import script from "./AgendaForm.vue?vue&type=script&lang=js"
export * from "./AgendaForm.vue?vue&type=script&lang=js"

import "./AgendaForm.vue?vue&type=style&index=0&id=3468ebae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3468ebae"]])

export default __exports__